// src/redux/slice/userContextSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userType: null,
  userId: null,
};

const userContextSlice = createSlice({
  name: "userContext",
  initialState,
  reducers: {
    setUserContext: (state, action) => {
      state.userType = action.payload.userType;
      state.userId = action.payload.userId;
    },
    clearUserContext: (state) => {
      state.userType = null;
      state.userId = null;
    },
  },
});

export const { setUserContext, clearUserContext } = userContextSlice.actions;
export default userContextSlice.reducer;
